import React, { useEffect, useState } from 'react';

//PACKS
import { connect } from 'react-redux';
import { Button, Alert, Navbar, Spinner, Card, Form, Modal, Container, Row, Col } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { Form as FinalForm, Field } from 'react-final-form';
import { UserPin } from '@styled-icons/boxicons-regular/UserPin';
import compareAsc from 'date-fns/compareAsc';
import { format } from 'date-fns';
import parseISO from 'date-fns/parseISO'
import _ from "lodash";

//Containers
import EsqueciSenha from './EsqueciSenha';
import ValidaCadastro from './ValidaCadastro';

//Components
import FormLogin from '../../../components/forms/logins/FormLogin';
import { campocaptch, campotexto } from '../../../components/forms/campos/campos';

//ACTIONS
import { pesquisa as pesquisatraducoes } from '../../../actions/traducoes/traducoes';
import { validaacesso, inicialogin } from '../../../actions/login/login';
import { pesquisa as pesquisaEmail } from '../../../actions/credenciamento/credencial';
import { pesquisa as pesquisapedido } from '../../../actions/pedidos/pedidos';
import { validaacesso as validaacessogerenciamento } from '../../../actions/logingerenciamento/login';

//TOOLS
import { getTraducaoTrocaPor as trad } from '../../../utils/getTraducoes';

//UTILS
import { setUserGeren } from '../../../utils/authusuariogerenciamento';
import { removeEvento } from '../../../utils/eventosession';
import { setTokenGerenciamento } from '../../../utils/tokencidtechapi';

import {
    setUserLoginCred,
    removeUserLoginCred,
    setLogoutusercred,
    setListenerProdutoRemovido,    
    setEmailConfirmacaoCred,
    getEvento
} from '../../../utils/eventosessioncred';

import { setToken } from '../../../utils/tokencidtechapi';

const Login = (props) => {

    const [eventoEcerrado, setEventoEcerrado] = useState(false);
    const [esquecisenha, setEsquecisenha] = useState(false);
    const [statusPesquisaEmail, setStatusPesquisaEmail] = useState(true);
    const [validarcad, setValidarcad] = useState(false);    
    const [traducaocarregada, setTraducaoCarregado] = useState(null);
    const [showModalImprimirCredencial, setShowModalImprimirCredencial] = useState(false);
    const [emailtentativaacesso, setEmailtentativaacesso] = useState('');

    let dados_basico = {
        idevento: props.idevento,
        idpromotora: props.idpromotora,
        lingua: props.lingua,
        categoria: props.categoriacred,
    }

    useEffect(async () => {
        await handlePesquisaTraducos();
        props.inicialogin();
        removeUserLoginCred();
        setTraducaoCarregado(true);
        setLogoutusercred();//Foi para tela de login, zera as sessões do usuário
        setListenerProdutoRemovido([]);
        setEmailConfirmacaoCred(0);
        removeEvento();
    }, []);

    useEffect(async () => {
        dados_basico = {
            ...dados_basico,
            lingua: props.lingua
        }
        await handlePesquisaTraducos();
    }, [props.lingua]);

    useEffect(async () => {
        dados_basico = {
            ...dados_basico,
            categoria: props.categoriacred
        }
    }, [props.categoriacred]);

    useEffect(() => {

        const evento = getEvento();

        if(evento&&evento.idevento&&evento.idevento>0){

            const dateatual = parseISO(format(new Date(),'yyyy-MM-dd'));
            const dateevento = parseISO(format(new Date(evento.datafinal+' 23:00:00'),'yyyy-MM-dd'));
            
            if(compareAsc(dateevento, dateatual) === 1){
                setEventoEcerrado(true);
            }
        }

    },[]);

    const handlePesquisaTraducos = async () => {
        const dados_basico_evento = {
            idevento: props.idevento,
            idpromotora: props.idpromotora
        }
        await props.pesquisatraducoes(
            {
                ...dados_basico_evento,
                wherein: JSON.stringify({
                    campo: 'identificador',
                    valores: ['conf_index']
                })
            }
        );
    }

    const handleEsqueciSenha = () => {
        props.inicialogin();
        setEsquecisenha(!esquecisenha ? true : false);
    }

    const handleValidarCad = () => {
        props.inicialogin();
        setValidarcad(!validarcad ? true : false);
    }

    const handleNovoCad = async () => {
        
        switch (props.idcategoria) {
            case 3://Gerenciamento
                props.history.push('/gerenciamento/login/cadastro');
                break;
            case 1://Credenciamento
                props.history.push('cadastro');
                break;
            default:
                break;
        }
    }

    const handleValidaAcessoGerenciamento = async (form = {}) => {
        const dados_gerenciamento = await props.validaacessogerenciamento({ email: form.email, password: form.senha });
        return dados_gerenciamento;
    }

    const handleValidaAcessoCredenciamento = async (forms = {}) => {
        const dados = await props.validaacesso(forms);
        return dados;
    }

    const onSubmit = async (form) => {
        console.log(form);
        let url_redirect = null;
        let dados_gerenciamento = {};
        let dados = {};
        let forms_dados = {};
        switch  (props.idcategoria)  {

            case 3://Gerenciamento
                dados_gerenciamento = await handleValidaAcessoGerenciamento(form);
                setUserGeren(dados_gerenciamento);
                if (dados_gerenciamento && dados_gerenciamento.id) {           
                    setTokenGerenciamento(dados_gerenciamento.token);
                    url_redirect = '/gerenciamento/dashboard';                    
                }
                break;

            case 1://Credenciamento
                
                forms_dados = {
                    idevento: props.idevento,
                    idpromotora: props.idpromotora,
                    idcategoriausuario: props.idcategoria,
                    ...form
                }

                setEmailtentativaacesso(form.email);
                dados = await handleValidaAcessoCredenciamento(forms_dados);
                if (dados && dados.idusuario) {
                    setToken(dados.token);
                    delete dados.token;

                    setUserLoginCred(dados);            
                    url_redirect = 'cadastro';
                }

                break;
                
            default:
                url_redirect = false;
                break;
        }
        
        if(url_redirect){
            setTimeout(() => {
                props.history.push(url_redirect);
            }, 2000);
        }
    }

    if (!props.trads.length || traducaocarregada === null) {
        return <Spinner style={{ margin: "auto" }} animation="border" />;
    }

    if (esquecisenha) {
        return (
            <EsqueciSenha
                handleVoltar={handleEsqueciSenha}
                {...props}
                {...dados_basico}
                idcategoria={props.idcategoria}
            />
        );
    }

    if (validarcad) {
        return (
            <ValidaCadastro
                handleVoltar={handleValidarCad}
                {...props}
                {...dados_basico}
                tipologin={props.idcategoria}
            />
        );
    }

    const handlePesquisaEmail = async (email) => {
        const res = await props.pesquisaEmail({
            idpromotora: dados_basico.idpromotora,
            idevento: dados_basico.idevento,
            email
        })
        return res;
    }

    const onSubmitImprimirCredencial = async (form) => {
        const credencial = await handlePesquisaEmail(form.email)

        if (_.isEmpty(credencial)) {
            setStatusPesquisaEmail(false)
            return false
        } else {
            setStatusPesquisaEmail(true)
            handleClose()
            handlePrintPdf(credencial)
        }
    }

    const handleClose = () => {
        setStatusPesquisaEmail(true)
        setShowModalImprimirCredencial(false)
    };
    const handleShow = () => {
        setStatusPesquisaEmail(true)
        setShowModalImprimirCredencial(true);
    }

    const handlePrintPdf = (credencial) => {
        const idcredencial_string = Buffer.from(`${credencial.idcredencial}`).toString('base64');
        const params = `?idpromotora=${dados_basico.idpromotora}&idevento=${dados_basico.idevento}&linguagem=${dados_basico.lingua}&aplicacao=credenciamento&idcredencial=${idcredencial_string}`;
        const url = `cidtechweb/api/credenciais/credencial/link/impressao${params}`;
        //const link = `${window.location.protocol}//${window.location.host}/${url}`;
        const link = `https://regtronweb.com.br/${url}`;        
        setTimeout(() => window.open(link, '_blank'), 2000);        
    }

    if(eventoEcerrado === true){        
        return (
            <Alert variant="danger">
                <Alert.Heading>Evento Encerrado/Event Closed!</Alert.Heading>                
            </Alert>
        );
    }

    return (
        <>
        <Card className="border-0">
            <Card.Body className="row justify-content-center">
                <FinalForm
                    onSubmit={onSubmit}
                    validate={values => {
                        const errors = {};
                        if (!values.email) {
                            errors.email = trad(props.trads, 'ERROEMAIL1', dados_basico.lingua);
                        }

                        if (!values.senha) {
                            errors.senha = trad(props.trads, 'ERROSENHA', dados_basico.lingua);
                        }

                        if (!values.validado) {
                            errors.validado = trad(props.trads, 'OBRIGATORIO', dados_basico.lingua);
                        }
                        return errors;
                    }}
                    render={({ form, pristine, submitting, handleSubmit }) => {

                        return (
                            <form onSubmit={handleSubmit}>

                                {props.loginoptionsaccess===null?
                                <Navbar bg="light" expand="lg" className="justify-content-center">
                                    <Navbar.Brand>{trad(props.trads, 'CONF_ACESSAR', dados_basico.lingua)}</Navbar.Brand>
                                    <UserPin size="60" />
                                </Navbar>
                                :
                                (
                                    props.loginoptionsaccess===true?
                                    <Navbar bg="light" expand="lg" className="justify-content-center">
                                        <Navbar.Brand>{trad(props.trads, 'CONF_ACESSAR', dados_basico.lingua)}</Navbar.Brand>
                                        <UserPin size="60" />
                                    </Navbar>
                                    :
                                    null
                                )}

                                {props.idcategoria === 3 ?//Gerenciamento
                                    props.loginResult && props.loginResult.result === true ?
                                        <Alert variant="success">{trad(props.trads, 'MSGLOGINOK', dados_basico.lingua)}</Alert>
                                        :
                                        props.loginResult && props.loginResult.result === false ?
                                            <Alert variant="warning">{trad(props.trads, 'MSGLOGINBAD', dados_basico.lingua)}</Alert>
                                            :
                                            null
                                    :
                                    null
                                }

                                {props.idcategoria === 1 ?//Credenciamento
                                    props.loginResult && props.loginResult.result === false ?
                                        props.loginResult && props.loginResult.emailexiste === false ?
                                            <Alert variant="info">
                                                E-mail: {<strong>{emailtentativaacesso}</strong>} não cadastrado no sistema, aproveite 
                                                <span onClick={handleNovoCad} onKeyDown={handleNovoCad} style={{cursor: 'pointer', textDecoration: 'underline', fontWeight: 'bold'}} tabIndex={0}>
                                                    clique aqui e faça um NOVO CADASTRO
                                                </span>
                                            </Alert>
                                        :
                                        props.loginResult && props.loginResult.validado === false ?
                                            <Alert variant="warning">{trad(props.trads, 'MSGLOGINNOVALID', dados_basico.lingua)}</Alert>
                                            :
                                            <Alert variant="warning">{trad(props.trads, 'MSGLOGINBAD', dados_basico.lingua)}</Alert>
                                        :
                                        props.loginResult && props.loginResult.result === true ?
                                            <Alert variant="success">{trad(props.trads, 'MSGLOGINOK', dados_basico.lingua)}</Alert>
                                            :
                                            null
                                    :
                                    null
                                }

                                {props.loginoptionsaccess===null?
                                <FormLogin                                    
                                    form={form}
                                    {...props}
                                />
                                :
                                (
                                    props.loginoptionsaccess===true?
                                    <FormLogin                                    
                                        form={form}
                                        {...props}
                                    />
                                    :
                                    null
                                )}
                                
                                {props.loginoptionsaccess===null?
                                <Card className="border-0">
                                    <div style={{ width: "304px", margin: "auto" }}>
                                        <Field type='text' name='validado' component={campocaptch} lingua={dados_basico.lingua} form={form} />
                                    </div>
                                </Card>
                                :
                                (
                                    props.loginoptionsaccess===true?
                                    <Card className="border-0">
                                        <div style={{ width: "304px", margin: "auto" }}>
                                            <Field type='text' name='validado' component={campocaptch} lingua={dados_basico.lingua} form={form} />
                                        </div>
                                    </Card>
                                    :
                                    null
                                )}

                                <Form.Row className="mt-1">

                                    {props.loginoptionsaccess===null?
                                    <Button
                                        className='order-1'
                                        id="btosubmit"
                                        variant="primary"
                                        size="lg"
                                        block
                                        type="submit"
                                        disabled={submitting || pristine}
                                    >
                                        {props.pendingTasks ?
                                            <Spinner animation="border" />
                                            :
                                            trad(props.trads, 'BT_AVANCAR2', dados_basico.lingua)
                                        }
                                    </Button>
                                    :
                                    (
                                        props.loginoptionsaccess===true?
                                        <Button
                                            className='order-1'
                                            id="btosubmit"
                                            variant="primary"
                                            size="lg"
                                            block
                                            type="submit"
                                            disabled={submitting || pristine}
                                        >
                                            {props.pendingTasks ?
                                                <Spinner animation="border" />
                                                :
                                                trad(props.trads, 'BT_AVANCAR2', dados_basico.lingua)
                                            }
                                        </Button>
                                        :
                                        <Button                     
                                            className='order-2'
                                            variant="secondary"
                                            size="lg"
                                            block
                                            type="button"
                                            onClick={props.handleLoginOptionsAccess}
                                        >
                                            {props.pendingTasks ?
                                                <Spinner animation="border" />
                                                :
                                                trad(props.trads, 'BT_AVANCAR4', dados_basico.lingua)
                                            }
                                        </Button>
                                    )}

                                    {props.loginoptionsaccess===null?
                                    <Button
                                        className='order-3'
                                        variant="secondary"
                                        size="lg"
                                        block
                                        type="button"
                                        onClick={handleEsqueciSenha}
                                    >
                                        {trad(props.trads, 'CONF_ESQUECI', dados_basico.lingua)}
                                    </Button>
                                    :
                                    (
                                        props.loginoptionsaccess===true?
                                        <Button
                                            className='order-3'
                                            variant="secondary"
                                            size="lg"
                                            block
                                            type="button"
                                            onClick={handleEsqueciSenha}
                                        >
                                            {trad(props.trads, 'CONF_ESQUECI', dados_basico.lingua)}
                                        </Button>
                                        :
                                        null
                                    )}

                                    {props.validacadastro && props.validacadastro === 'S' ?
                                        <Button
                                            className='order-5'
                                            variant="secondary"
                                            size="lg"
                                            block
                                            type="button"
                                            onClick={handleValidarCad}
                                        >
                                            {trad(props.trads, 'BTVALIDATECAD', dados_basico.lingua)}
                                        </Button>
                                        :
                                        null
                                    }

                                    <Button
                                        className={props.loginoptionsaccess===null||props.loginoptionsaccess===true?"order-2":"order-1 mb-2"}
                                        variant={props.loginoptionsaccess===null||props.loginoptionsaccess===true?"secondary":"primary"}
                                        size="lg"
                                        block
                                        type="button"
                                        onClick={handleNovoCad}
                                    >
                                        {trad(props.trads, 'CONF_CAD', dados_basico.lingua)}
                                    </Button>

                                    <Button
                                        className='order-6'
                                        variant="secondary"
                                        size="lg"
                                        block
                                        type="button"
                                        onClick={handleShow}
                                    >
                                        {trad(props.trads, 'BTIMPRIMIRCREDENCIAL', dados_basico.lingua)}
                                    </Button>

                                </Form.Row>

                            </form>
                        )}
                    }
                />
            </Card.Body>
        </Card>
        <Modal show={showModalImprimirCredencial} onHide={handleClose}>
            <FinalForm
                onSubmit={onSubmitImprimirCredencial}
                validate={(values) => {
                    const errors = {};
                    if (!values.email) {
                        errors.email = trad(props.trads, 'ERROEMAIL1', dados_basico.lingua);
                    }
                    if (!values.validado) {
                        errors.validado = trad(props.trads, 'OBRIGATORIO', dados_basico.lingua);
                    }
                    return errors;
                }}
                render={({ form, handleSubmit }) => (

                    <form onSubmit={handleSubmit}>
                        <Modal.Header closeButton>
                            <Modal.Title>Digite o email cadastrado</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Container>
                                <Row>
                                    <Col>
                                        <Field type='text' name='email' label='E-mail' component={campotexto} />
                                        {!statusPesquisaEmail ?
                                            <Alert variant="warning">Email não encontrado</Alert>
                                            : null}
                                    </Col>
                                </Row>

                                <Row>
                                    <Col>

                                        <Card className="border-0">
                                            <div style={{ width: "304px", margin: "auto" }}>
                                                <Field type='text' name='validado' component={campocaptch} lingua={dados_basico.lingua} form={form} />
                                            </div>
                                        </Card>

                                    </Col>
                                </Row>
                            </Container>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Sair
                            </Button>
                            <Button variant="primary" type="submit">
                                {props.pendingTasks ?
                                    <Spinner animation="border" />
                                    :
                                    "Imprimir Credencial"
                                }
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            />
        </Modal>
        </>
    )

}

const mapStateToProps = (state) => {
    return {
        trads: state.reducerTraducoes,
        pendingTasks: state.pendingTasks,
        loginResult: state.loginValidaReducer
    }
}

export default connect(mapStateToProps, {
    pesquisatraducoes,
    validaacesso,
    inicialogin,
    validaacessogerenciamento,
    pesquisapedido,
    pesquisaEmail
})(withRouter(Login));